/**
 * Created by Administrador on 10/3/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('User', UserService);

    UserService.$inject = ['$resource', 'CONFIG', 'messageService'];

    function UserService($resource, CONFIG, messageService) {
        var urlBaseOauth = CONFIG.API_URL + '/uaa';

        return $resource(urlBaseOauth + '/account', {
            get: {
                method: 'GET'
            }
        });
    }
})();
